import _ from 'lodash';

import { canManageBusinessReports } from 'containers/report-jobs/permissions';
import querystring from 'utils/querystring';

export default function selector(storeState) {
    const businessReportDashboardState = _.get(storeState, 'businessReportDashboard');
    const businessReportsResource = _.get(storeState, 'resources.businessReports', {});
    const organizationTimezone = _.get(storeState, 'profile.organizationTimezone');
    const globalRole = _.get(storeState, 'profile.globalRole');

    const filters = querystring.parse(window.location.href.split('?')[1]);
    const {
        pagination,
        isDeleteConfirmationModalOpen,
        businessReportToDelete,
        allBusinessReportCount,
        myBusinessReportCount,
    } = businessReportDashboardState;

    const businessReports = _(pagination[filters.page || 1])
        .map(id => businessReportsResource[id])
        .filter(br => br)
        .map(br => br.attr)
        .value();

    return {
        businessReportDashboardState,
        businessReports,
        organizationTimezone,
        canManageReports: canManageBusinessReports(globalRole),
        isDeleteConfirmationModalOpen,
        businessReportToDelete,
        businessReportsResource,
        allBusinessReportCount,
        myBusinessReportCount,
    };
}
